import type { Filters } from 'hooks/store/temperature-control/use-equipment-search-params';
import type { FormSchema } from './form-schema';

export const createFilters = (formData: FormSchema): Filters => {
  return formData;
};

export const createReportParams = (formData: FormSchema) => {
  const filters = createFilters(formData);
  return createSearchParams(filters);
};

export const createSearchParams = (filters: Filters) => {
  const params = { ...filters };

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // @ts-ignore
      params[key] = value.toString();
    }
  });

  Object.entries(params).forEach(([key, value]) => {
    if (!value) {
      // @ts-ignore
      delete params[key];
    }
  });

  return params;
};